
import React, { useEffect, useState } from 'react';
import { v4 as uuidV4 } from 'uuid';

import './classic-bus-row.css'
import RotatingBusBanner from '../RotatingBusBanner';

export default function ClassicBusRow({ busses, busBannerTick, bannerId }) {

  return (
    <div className='classic-bus-outer-row-component'>
        <div className='classic-bus-half-component-left'>
            <RotatingBusBanner 
                busses={busses.busStopOne}
                busBannerTick={busBannerTick}
                bannerId={bannerId}
                key={bannerId + '-one'}
            />
        </div>
        <div className='classic-bus-half-component-right'>
            <RotatingBusBanner 
                busses={busses.busStopTwo}
                busBannerTick={busBannerTick}
                bannerId={bannerId}
                key={bannerId + '-two'}
            /> 
        </div>
    </div>
  );
}
